import Layout from "components/Layout";
import React from "react";
import DeviceDataTable from "./components/DeviceDataTable";

function Device() {
  return (
    <Layout title="장치 목록">
      <DeviceDataTable />
    </Layout>
  );
}

export default Device;
